import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rikrdguv4vgt">
      <MetaPixel data-id="element-1" data-mp="2mjpx9irg3khe" />
      <Hero data-id="element-2" data-mp="31aqf2ee30qq7" />
      <StatsAndProof data-id="element-3" data-mp="31b8j3x6zk98o" />
      <PainPoints data-id="element-4" data-mp="31bs0ncsq4vm6" />
      <ProductOffer data-id="element-5" data-mp="31c9uk2rwyxqx" />
      <Pricing showAnchor data-id="element-6" data-mp="31ctaxf1x1e2u" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wk9y4kb1ymz3" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wiyv4mpflj91" />
      <CostSection data-id="element-9" data-mp="2wip7h5ruzo6i" />
      <Pricing data-id="element-10" data-mp="2wi5m1f302hnq" />
      <FooterAndProofPopup data-id="element-11" data-mp="28u5zysgmvffh" />
    </main>;
}